"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var map_like_1 = require("map-like");
/*

## UseCase instance lifecycle

Each UseCase instance is managed by UseCaseInstanceMap.

P: Parent UseCase
C: Child UseCase
Add: Add instance to UseCaseInstanceMap
Delete: Remove instance from UseCaseInstanceMap

    Add P         Delete P   Delete C
    |---------------|          |
    P    |                     |
         C---------------------|
      Add C              |
                         |
                     Point X

If C refer to P on `Point X`, it will not be working correctly.
Almin will say that `This P(parent UseCase) is already released!"

See also https://almin.js.org/docs/warnings/usecase-is-already-released.html
 */
/**
 * This Map maintains a mapping instance of UseCase
 * A UseCase will execute and add it to this map.
 * A UseCase was completed and remove it from this map.
 */
exports.UseCaseInstanceMap = new map_like_1.MapLike();
//# sourceMappingURL=UseCaseInstanceMap.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UseCaseInstanceMap.js
// module id = 475
// module chunks = 0